import { Box, Typography } from "@mui/material";
import InfoCellSkeleton from "./skeleton";
import React from "react";

export default function InfoCell({
  title,
  description,
  descriptionFallback = "N/A",
  isLoading,
  icon,
}: {
  title: string;
  description?: string | React.ReactNode;
  descriptionFallback?: string;
  isLoading?: boolean;
  icon?: React.ReactNode;
}) {
  return (
    <Box
      sx={(t) => ({
        display: "flex",
        gap: t.nawy.spacing.sm,
        alignItems: "center",
      })}
    >
      {icon}
      <Box
        sx={{
          minWidth: "92px",
        }}
      >
        <Typography
          sx={(theme) => ({
            ...theme.nawy.typography.english.variants.body.xs.regular,
            color: theme.nawy.colors.semantic.text.secondary,
          })}
        >
          {title}
        </Typography>
        {isLoading ? (
          <InfoCellSkeleton />
        ) : (
          <Typography
            sx={(theme) =>
              ({...theme.nawy.typography.english.variants.body.md.regular,
                whiteSpace: 'pre-line'
              })
            }
          >
            {description ?? descriptionFallback}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
